import { MagicConfigMixin } from '@gig/magic-common';
import { __extends, __decorate, __metadata } from 'tslib';
import { Prop, Watch, Emit, Component, Mixins } from 'vue-property-decorator';
import { MagicEmit } from '@gig/magic-common/dist/util';

/**
 * Component that renders an input field with defined type. Allows to have
 * a space for icons or render centered text inside of input field.
 */
var InputComponent = /** @class */ (function (_super) {
    __extends(InputComponent, _super);
    function InputComponent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.wheelHandler = null;
        return _this;
    }
    Object.defineProperty(InputComponent.prototype, "inputType", {
        get: function () {
            // Handle telephone as numeric for input validation purposes.
            if (this.type === 'tel') {
                return 'number';
            }
            return this.type;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InputComponent.prototype, "pattern", {
        get: function () {
            if (this.type === 'tel') {
                return '\\d*';
            }
            return this.$attrs.pattern;
        },
        enumerable: false,
        configurable: true
    });
    InputComponent.prototype.onWheel = function (event) {
        if (this.type === 'tel') {
            event.preventDefault();
        }
    };
    InputComponent.prototype.mounted = function () {
        if (!this.$el) {
            return;
        }
        // TODO: Do this in the template once https://github.com/vuejs/vue/issues/10778 is sorted
        this.wheelHandler = this.onWheel.bind(this);
        this.$el.addEventListener('wheel', this.wheelHandler, {
            passive: false,
        });
    };
    InputComponent.prototype.destroyed = function () {
        if (this.wheelHandler) {
            this.$el.removeEventListener('wheel', this.wheelHandler);
        }
    };
    InputComponent.prototype.onChange = function (event) {
        var target = event.target;
        return target.value;
    };
    InputComponent.prototype.onFocusChange = function () {
        var _this = this;
        if (this.focused) {
            this.$nextTick(function () {
                _this.$el.focus();
            });
        }
    };
    InputComponent.prototype.onInput = function (event) {
        var target = event.target;
        return target.value;
    };
    InputComponent.prototype.onErase = function (event) {
        return event;
    };
    __decorate([
        Prop(Boolean),
        __metadata("design:type", Boolean)
    ], InputComponent.prototype, "icon", void 0);
    __decorate([
        Prop(Boolean),
        __metadata("design:type", Boolean)
    ], InputComponent.prototype, "centered", void 0);
    __decorate([
        Prop(Boolean),
        __metadata("design:type", Boolean)
    ], InputComponent.prototype, "small", void 0);
    __decorate([
        Prop(Boolean),
        __metadata("design:type", Boolean)
    ], InputComponent.prototype, "focused", void 0);
    __decorate([
        Prop(String),
        __metadata("design:type", String)
    ], InputComponent.prototype, "type", void 0);
    __decorate([
        Prop(Boolean),
        __metadata("design:type", Boolean)
    ], InputComponent.prototype, "ellipsis", void 0);
    __decorate([
        MagicEmit('change'),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Event]),
        __metadata("design:returntype", void 0)
    ], InputComponent.prototype, "onChange", null);
    __decorate([
        Watch('focused', { immediate: true }),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], InputComponent.prototype, "onFocusChange", null);
    __decorate([
        MagicEmit('input'),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Event]),
        __metadata("design:returntype", void 0)
    ], InputComponent.prototype, "onInput", null);
    __decorate([
        Emit('erase'),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [KeyboardEvent]),
        __metadata("design:returntype", void 0)
    ], InputComponent.prototype, "onErase", null);
    InputComponent = __decorate([
        Component({
            name: 'ui-input',
            inheritAttrs: false,
        })
    ], InputComponent);
    return InputComponent;
}(Mixins(MagicConfigMixin)));

export default InputComponent;
